import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
// import { ReactComponent as CloseIcon } from 'src/assets/icons/close.svg';
import { ReactComponent as BuyIcon } from 'src/assets/icons/bonus-game/buy-crypto.svg';
import { ReactComponent as ReceiveIcon } from 'src/assets/icons/bonus-game/receive-modal-icon.svg';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  backdrop-filter: blur(10px);
`;

const ModalContainer = styled.div`
  background-color: #10141b;
  border-radius: 20px 20px 0 0;
  width: 100%;
  max-width: 500px;
  padding: 20px;
  animation: slideUp 0.3s ease-out forwards;
  position: relative;

  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-bottom: 20px;
`;

const ModalTitle = styled.h2`
  color: #ffffff;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  text-align: center;
`;

const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
`;

const CurrentMultiplier = styled.p`
  color: #b4bbc3;
  font-size: 14px;
  margin: 0 0 20px 0;
  text-align: center;
`;

const InstructionText = styled.p`
  color: #b4bbc3;
  font-size: 14px;
  margin: 0 0 30px 0;
  text-align: center;
  line-height: 1.5;
`;

const HighlightedText = styled.span`
  color: #b9f53a;
  font-weight: 600;
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 20px;
  width: 100%;
`;

const ActionButton = styled.button`
  background-color: #171d25;
  border: 1px solid #29313e;
  border-radius: 12px;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  flex: 1;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
`;

const LaterButton = styled.button`
  background-color: transparent;
  border: 1px solid #29313e;
  border-radius: 12px;
  padding: 15px;
  width: 100%;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;

const BottomBar = styled.div`
  width: 40px;
  height: 5px;
  background-color: #29313e;
  border-radius: 3px;
  margin: 0 auto 20px;
`;

interface MultiplierModalProps {
  closeModal: () => void;
  multiplier: number | string;
}

export const MultiplierModal = ({
  closeModal,
  multiplier,
}: MultiplierModalProps) => {
  const handleBuyCrypto = () => {
    (window as any).ReactNativeWebView?.postMessage(
      JSON.stringify({ type: 'navigate', data: { screen: 'Buy' } }),
    );
    closeModal();
  };

  const handleReceiveCrypto = () => {
    (window as any).ReactNativeWebView?.postMessage(
      JSON.stringify({ type: 'navigate', data: { screen: 'Receive' } }),
    );
    closeModal();
  };

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContainer>
        <ModalHeader>
          <ModalTitle>How Multiplier works?</ModalTitle>
          <CloseButton onClick={closeModal}></CloseButton>
        </ModalHeader>
        <ModalContent>
          <CurrentMultiplier>
            You currently have an{' '}
            <HighlightedText>x{multiplier}</HighlightedText> multiplier.
          </CurrentMultiplier>
          <InstructionText>
            To boost your rewards to <HighlightedText>x2</HighlightedText>, keep
            a balance of
            <HighlightedText> $100</HighlightedText> or more in your account.
          </InstructionText>

          <ButtonsContainer>
            <ActionButton onClick={handleBuyCrypto}>
              <BuyIcon />
              Buy crypto
            </ActionButton>
            <ActionButton onClick={handleReceiveCrypto}>
              <ReceiveIcon />
              Receive crypto
            </ActionButton>
          </ButtonsContainer>

          <LaterButton onClick={closeModal}>Later</LaterButton>
        </ModalContent>
      </ModalContainer>
    </ModalOverlay>
  );
};
